import { Button, Sheet } from '@gravity-ui/uikit';

import styles from './styles.module.scss';

export const DocumentSheet = ({ open, onClose, pdfSrc }: any) => {
	return (
		<Sheet visible={open} onClose={onClose} className={styles.sheet_document}>
			<div className={styles.sheet_document__content}>
				<iframe src={pdfSrc} />
			</div>
			<Button onClick={onClose} className={styles.sheet_document__btn} size="l">
				Закрыть
			</Button>
		</Sheet>
	);
};
